// extracted by mini-css-extract-plugin
export default {"MyCreateDialog2":"MyCreateDialog2_MyCreateDialog2__1UK9q","photo":"MyCreateDialog2_photo__Ag6oE","containerImage":"MyCreateDialog2_containerImage__hUYzf"};